module.exports = __webpack_public_path__ + "static/media/cracker.51a40268.mov";